import {
  Button,
  CloseButton,
  Flex,
  Heading,
  IconArrowEndLine,
  IconInfoSolid,
  Modal,
  Pill,
  Spinner,
  Text,
  Tooltip,
} from "@instructure/ui";
import { t } from "i18next";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { AttainmentRuleService } from "../../../services/AttainmentRuleService";
import { MappingsService } from "../../../services/MappingService";
import { FeatureContext, UserDetailContext } from "../../../utils/Context";
import { TruncateToolTip } from "../../../utils/TruncateTooltip";
import { sort } from "../../../utils/utils";
import { ERROR, useNotification } from "../../CustomHooks/NotificationProvider";
import { Selector } from "../../Selectors/Selector";
import Badging from "../Badging";
import CourseOptions from "../CourseOptions";

// using null for ilo/ploAssignmentTypes where that is not the learningOutcomeType to differentiate between
// having an empty list of the correct type vs nothing of the incorrect type when building the backend mapping properties
const MappingDetailsModal = ({
  openModal,
  modalData,
  outcome,
  handleCloseModal,
  attainments,
  // assignmentTypeCourse,
  // assignmentTypeIloPlo,
  deleteMapping,
  saveMapping,
  learningOutcomeType,
  dash,
  // updateRatingScale,
  setBadgeMappings,
  futureMap,
}) => {
  const userDetails = useContext(UserDetailContext);
  const features = useContext(FeatureContext);
  const showNotification = useNotification();
  // const [addTypesModalOpen, setAddTypesModalOpen] = useState(false);
  // const [assignmentTypes, setAssignmentTypes] = useState([]);
  const [attainmentLevel, setAttainmentLevel] = useState("");
  // const [facultyCourseAssignments, setFacultyCourseAssignments] = useState([]);
  // const [facultyIloPloAssignments, setFacultyIloPloAssignments] = useState([]);
  // const [rubricId, setRubricId] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [applyBadge, setApplyBadge] = useState(!!modalData.badgeMapping);
  const [selectedBadge, setSelectedBadge] = useState(null);
  const [badgingFlag, setBadgingFlag] = useState(false);
  const [loSyncFlag, setLoSyncFlag] = useState(false);

  const [syncedMappings, setSyncedMappings] = useState();
  const [loSync, setLoSync] = useState(false);

  useEffect(() => {
    if (loSyncFlag && openModal && outcome.course_summary) {
      MappingsService.getAllSyncedMappingsForContext(
        outcome.id,
        futureMap
      ).then((mappings) => {
        if (mappings) {
          mappings = mappings.filter((mapping) => mapping.id !== modalData.to);
          mappings = sort(mappings, (mapping) => mapping.name);
          setSyncedMappings(mappings);
        } else {
          setSyncedMappings([]);
        }
      });
    }
  }, [outcome, openModal, futureMap, loSyncFlag]);

  useEffect(() => {
    if (features.find((f) => f.name === "badging_flag")?.value === "TRUE") {
      setBadgingFlag(true);
    }
    if (
      features.find((f) => f.name === "ilo_plo_sync_flag")?.value === "TRUE"
    ) {
      setLoSyncFlag(true);
    }
  }, [features]);

  // useEffect(() => {
  //   if (!!openModal) {
  //     AssignmentTypeService.getAssignmentTypes().then((r) => {
  //       setAssignmentTypes(
  //         r.map((type) => ({
  //           id: type.id,
  //           title: type.name,
  //           name: type.name,
  //           label: type.name,
  //         }))
  //       );
  //     });
  //   }
  // }, [openModal]);

  useLayoutEffect(() => {
    setAttainmentLevel(modalData?.properties?.degreesOfLearning ?? "");
    setLoSync(modalData?.properties?.lo_sync ?? false);
    // if (dash) {
    //   if (modalData && modalData.properties) {
    //     if (
    //       modalData.properties.assignmentTypes &&
    //       typeof modalData.properties.assignmentTypes === "string"
    //     ) {
    //       setFacultyCourseAssignments(
    //         modalData.properties.assignmentTypes.split(",")
    //       );
    //     } else if (
    //       modalData.properties.assignmentTypes &&
    //       typeof modalData.properties.assignmentTypes === "object"
    //     ) {
    //       setFacultyCourseAssignments(modalData.properties.assignmentTypes);
    //     } else {
    //       setFacultyCourseAssignments([]);
    //     }
    //     if (modalData.properties.iloAssignmentTypes) {
    //       modalData.properties.ploAssignmentTypes = null;
    //       if (typeof modalData.properties.iloAssignmentTypes === "string") {
    //         setFacultyIloPloAssignments(
    //           modalData.properties.iloAssignmentTypes.split(",")
    //         );
    //       } else if (
    //         typeof modalData.properties.iloAssignmentTypes === "object"
    //       ) {
    //         setFacultyIloPloAssignments(
    //           modalData.properties.iloAssignmentTypes
    //         );
    //       } else {
    //         setFacultyIloPloAssignments([]);
    //       }
    //     } else if (modalData.properties.ploAssignmentTypes) {
    //       modalData.properties.iloAssignmentTypes = null;
    //       if (typeof modalData.properties.ploAssignmentTypes === "string") {
    //         setFacultyIloPloAssignments(
    //           modalData.properties.ploAssignmentTypes.split(",")
    //         );
    //       } else if (
    //         typeof modalData.properties.ploAssignmentTypes === "object"
    //       ) {
    //         setFacultyIloPloAssignments(
    //           modalData.properties.ploAssignmentTypes
    //         );
    //       } else {
    //         setFacultyIloPloAssignments([]);
    //       }
    //     } else {
    //       setFacultyIloPloAssignments([]);
    //     }
    //   } else {
    //     setFacultyCourseAssignments([]);
    //     setFacultyIloPloAssignments([]);
    //   }
    // }
  }, [modalData]);

  // useEffect(() => {
  //   if (rubricId) {
  //     updateRatingScale(rubricId, modalData);
  //   }
  // }, [rubricId]);

  // const handleSelectedCourseAssignmentType = (values) => {
  //   if (modalData) {
  //     if (!modalData.properties) {
  //       modalData.properties = {};
  //     }
  //     modalData.properties.assignmentTypes = values;
  //   }
  // };

  // const handleSelectedIloPloAssignmentType = (values) => {
  //   if (modalData) {
  //     if (!modalData.properties) {
  //       modalData.properties = {};
  //     }
  //     if (learningOutcomeType === "islo") {
  //       modalData.properties.iloAssignmentTypes = values;
  //       modalData.properties.ploAssignmentTypes = null;
  //     } else if (learningOutcomeType === "pslo") {
  //       modalData.properties.ploAssignmentTypes = values;
  //       modalData.properties.iloAssignmentTypes = null;
  //     }
  //   }
  // };

  const handleSelectedAttainment = (value) => {
    if (modalData) {
      if (!modalData.properties) {
        modalData.properties = {};
      }
      const selectedAttainment = attainments.find(
        (attainment) => attainment.id === value
      );
      modalData.properties.degreesOfLearning = selectedAttainment.label;
      setAttainmentLevel(selectedAttainment.label);
    }
  };

  const handleLoSyncCheck = (checked) => {
    if (modalData) {
      if (!modalData.properties) {
        modalData.properties = {};
      }
      modalData.properties.lo_sync = checked;
      setLoSync(checked);
    }
  };

  // const handleAddTypesModal = () => {
  //   setAddTypesModalOpen(true);
  // };

  // const getToolTip = (text) => (
  //   <div style={{ fontSize: "small", marginTop: 5 }}>
  //     <Tooltip
  //       color="primary-inverse"
  //       renderTip={<div style={{ maxWidth: 250 }}>{text}</div>}
  //       placement="start"
  //       offsetX="5px"
  //     >
  //       {text}
  //     </Tooltip>
  //   </div>
  // );

  const handleUpsertBadgeMapping = async () => {
    const body = {
      id: modalData.badgeMapping?.id,
      openBadgeId: selectedBadge.openBadgeId,
      issuerOpenBadgeId: selectedBadge.issuerOpenBadgeId,
      sourceOutcomeId: modalData.from,
      targetOutcomeId: modalData.to,
      lifeCycle: futureMap?.current ? "current" : "future",
    };

    const badgeMappingPromise = body.id
      ? AttainmentRuleService.updateBadgeMapping(body)
      : AttainmentRuleService.createBadgeMapping(body);

    try {
      const badgeMapping = await badgeMappingPromise;
      if (body.id) {
        setBadgeMappings((prev) => {
          const index = prev.findIndex((b) => b.id === badgeMapping.id);
          prev[index] = badgeMapping;
          return prev;
        });
      } else {
        setBadgeMappings((prev) => [...prev, badgeMapping]);
      }
    } catch {
      showNotification(
        t("notifications.general.updateError", {
          obj: t("badging.badgeMapping"),
        }),
        ERROR
      );
    }
  };

  const handleDeleteBadgeMapping = () => {
    if (modalData.badgeMapping) {
      AttainmentRuleService.deleteBadgeMapping(modalData.badgeMapping.id)
        .then(() => {
          setBadgeMappings((prevMappings) =>
            prevMappings.filter(
              (mapping) => mapping.id !== modalData.badgeMapping.id
            )
          );
        })
        .catch(() => {
          showNotification(
            t("notifications.general.deleteError", {
              obj: t("badging.badgeMapping"),
            }),
            ERROR
          );
        });
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    applyBadge ? handleUpsertBadgeMapping() : handleDeleteBadgeMapping();
    await saveMapping(e, modalData);
    setLoading(false);
  };

  const checkEditable = () => {
    if (futureMap && futureMap?.authors) {
      const author = futureMap.authors.find(
        (author) => author.id === userDetails.ddl_id
      );
      if (author?.state === "in progress") {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      <Modal
        open={openModal}
        onExited={() => {
          handleCloseModal();
          // setFacultyCourseAssignments([]);
          // setFacultyIloPloAssignments([]);
          setSelectedBadge(null);
          setApplyBadge(!!modalData.badgeMapping);
          setSyncedMappings(null);
        }}
        size="medium"
        label={t("curriculumMap.modalLabel")}
        onDismiss={handleCloseModal}
      >
        <Modal.Header>
          <Flex justifyItems="space-between">
            <Flex.Item>
              <Heading level="h2" as="h1">
                {t("curriculumMap.mappingDetails")}
              </Heading>
            </Flex.Item>
            <Flex.Item>
              <CloseButton
                onClick={handleCloseModal}
                screenReaderLabel={t("global.close")}
              />
            </Flex.Item>
          </Flex>
        </Modal.Header>
        <Modal.Body>
          <Flex wrap="wrap" gap="medium">
            <Flex.Item width="45%">
              <TruncateToolTip
                renderTip={
                  <div style={{ maxWidth: 250 }}>
                    {modalData?.courseName ?? ""}
                  </div>
                }
                maxLines={2}
              >
                <Text size="small">{modalData?.courseName ?? ""}</Text>
              </TruncateToolTip>
            </Flex.Item>
            <Flex.Item width="5%">
              <IconArrowEndLine />
            </Flex.Item>
            <Flex.Item width="40%" hAlign="start">
              <TruncateToolTip
                renderTip={
                  <div style={{ maxWidth: 250 }}>{modalData?.loName ?? ""}</div>
                }
                maxLines={2}
              >
                <Text size="small">{modalData?.loName ?? ""}</Text>
              </TruncateToolTip>
            </Flex.Item>
            <Flex.Item width="100%">
              {!dash && checkEditable() ? (
                <Selector
                  id={"attainment-level-select"}
                  label={
                    <Text size="small">
                      {t("attainmentLevel.selectAttainmentLevel")}{" "}
                      <Tooltip
                        renderTip={
                          <div style={{ width: 500 }}>
                            {t("assignment.mappingAssociations")}
                          </div>
                        }
                        placement="end"
                        on={["click", "hover", "focus"]}
                        color="primary-inverse"
                      >
                        <IconInfoSolid color="brand" tabIndex={0} />
                      </Tooltip>
                    </Text>
                  }
                  selectHandler={handleSelectedAttainment}
                  options={attainments}
                  selectedItemId={
                    attainmentLevel &&
                    attainments.find(
                      (attainment) => attainment.label === attainmentLevel
                    ).id
                  }
                  size="small"
                />
              ) : (
                <Text weight="bold">
                  {t("attainmentLevel.selectedTitle")}{" "}
                  {attainmentLevel ? (
                    <Pill color="info" margin="0 x-small">
                      {attainmentLevel}
                    </Pill>
                  ) : (
                    <Text weight="normal">
                      {t("attainmentLevel.noLevelSet")}
                    </Text>
                  )}
                </Text>
              )}
            </Flex.Item>
            {badgingFlag && (
              <Flex.Item width="100%">
                <Badging
                  modalData={modalData}
                  selectedBadge={selectedBadge}
                  setSelectedBadge={setSelectedBadge}
                  applyBadge={applyBadge}
                  setApplyBadge={setApplyBadge}
                  readOnly={!checkEditable()}
                />
              </Flex.Item>
            )}
            {outcome.course_summary && loSyncFlag && (
              <Flex.Item width="100%">
                <CourseOptions
                  loSync={loSync}
                  handleLoSyncCheck={handleLoSyncCheck}
                  course={outcome}
                  syncedMappings={syncedMappings}
                  learningOutcomeType={learningOutcomeType}
                  readOnly={!checkEditable()}
                  isFutureMap={!!futureMap}
                />
              </Flex.Item>
            )}
          </Flex>
          {/* <Grid vAlign="top">
            <Grid.Row>
                  <Grid.Col>
                    <Heading margin="0 0 small 0" level="h4" as="h2">
                      {t("assignment.courseCloAssignmentTypes")}
                    </Heading>
                    <Grid vAlign="middle">
                      <Grid.Row>
                        {!dash ? (
                          <Grid.Col width={11}>
                            <AssignmentTypeSelect
                              id="course-assignment-selector"
                              selectHandler={handleSelectedCourseAssignmentType}
                              assignmentTypes={assignmentTypes}
                              label=""
                              selectedOptions={assignmentTypeCourse}
                              type="course"
                              comparableData={assignmentTypeIloPlo}
                            />{" "}
                          </Grid.Col>
                        ) : (
                          <Grid.Col width={11}>
                            {facultyCourseAssignments.length > 0 ? (
                              <List isUnstyled>
                                {facultyCourseAssignments.map((col) => {
                                  return assignmentTypes.map((type, key) => {
                                    if (col === type.id) {
                                      return (
                                        <List.Item key={key}>
                                          <Text size="small" weight="bold">
                                            {type.name}{" "}
                                            {facultyIloPloAssignments.map(
                                              (ilo, idx) => {
                                                if (col === ilo) {
                                                  return (
                                                    <span
                                                      key={idx}
                                                      style={{ marginRight: 5 }}
                                                    >
                                                      <IconStandardsSolid color="success" />
                                                    </span>
                                                  );
                                                } else {
                                                  return null;
                                                }
                                              }
                                            )}
                                          </Text>
                                        </List.Item>
                                      );
                                    }
                                  });
                                })}
                              </List>
                            ) : (
                              <Text size="small" weight="bold">
                                {t("assignment.noAssignmentsSet")}
                              </Text>
                            )}
                          </Grid.Col>
                        )}
                      </Grid.Row>
                    </Grid>
                  </Grid.Col>
                  <Grid.Col>
                    <Heading margin="0 0 small 0" level="h4" as="h2">
                      {t("assignment.IloPloAssignmentTypes")}
                    </Heading>
                    <Grid vAlign="middle">
                      <Grid.Row>
                        {!dash ? (
                          <Grid.Col width={11}>
                            <AssignmentTypeSelect
                              id="ilo-plo-assignment-selector"
                              selectHandler={handleSelectedIloPloAssignmentType}
                              assignmentTypes={assignmentTypes}
                              label=""
                              selectedOptions={assignmentTypeIloPlo}
                              type={learningOutcomeType}
                              comparableData={assignmentTypeCourse}
                            />
                          </Grid.Col>
                        ) : (
                          <Grid.Col width={11}>
                            {facultyIloPloAssignments.length > 0 ? (
                              <List isUnstyled>
                                {facultyIloPloAssignments.map((col) => {
                                  return assignmentTypes.map((type, key) => {
                                    if (col === type.id) {
                                      return (
                                        <List.Item key={key}>
                                          <Text size="small" weight="bold">
                                            {type.name}{" "}
                                            {facultyCourseAssignments.map(
                                              (clo, idx) => {
                                                if (col === clo) {
                                                  return (
                                                    <span
                                                      key={idx}
                                                      style={{ marginRight: 5 }}
                                                    >
                                                      <IconStandardsSolid color="success" />
                                                    </span>
                                                  );
                                                } else {
                                                  return null;
                                                }
                                              }
                                            )}
                                          </Text>
                                        </List.Item>
                                      );
                                    }
                                  });
                                })}
                              </List>
                            ) : (
                              <Text size="small" weight="bold">
                                {t("assignment.noAssignmentsSet")}
                              </Text>
                            )}
                          </Grid.Col>
                        )}
                      </Grid.Row>
                    </Grid>
                  </Grid.Col>
                </Grid.Row>
            <Grid.Row style={{ marginTop: -5 }}>
                  <Grid.Col>
                    {!dash && (
                      <Button
                        size="small"
                        renderIcon={IconAddLine}
                        onClick={handleAddTypesModal}
                      >
                        {t("assignment.addAssignmentTypeButton")}
                      </Button>
                    )}
                  </Grid.Col>
                </Grid.Row>
          </Grid> */}
        </Modal.Body>
        {dash !== true && (
          <Modal.Footer>
            <Button onClick={handleCloseModal} margin="0 x-small 0 0">
              {t("global.cancel")}
            </Button>
            {modalData && modalData.id && checkEditable() && (
              <Button
                onClick={async () => {
                  setLoadingDelete(true);
                  await deleteMapping(modalData, false);
                  setLoadingDelete(false);
                }}
                color="danger"
                margin="0 x-small 0 0"
                disabled={loadingDelete}
              >
                {loadingDelete ? (
                  <Spinner
                    size="x-small"
                    renderTitle={t("curriculumMap.deleteSpinner")}
                  />
                ) : (
                  <Text>{t("curriculumMap.deleteMapping")}</Text>
                )}
              </Button>
            )}
            {checkEditable() && (
              <Button color="primary" onClick={handleSubmit} disabled={loading}>
                {loading ? (
                  <Spinner
                    size="x-small"
                    renderTitle={t("curriculumMap.saveSpinner")}
                  />
                ) : (
                  <Text>{t("curriculumMap.saveMapping")}</Text>
                )}
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>
      {/* <AssignmentTypesModal
        addTypesModalOpen={addTypesModalOpen}
        setAddTypesModalOpen={setAddTypesModalOpen}
        handleCloseTypesModal={() => setAddTypesModalOpen(false)}
        setAssignmentTypes={setAssignmentTypes}
      /> */}
    </>
  );
};

export default MappingDetailsModal;
